var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('heard'),_c('div',{staticClass:"main"},[_c('div',{domProps:{"innerHTML":_vm._s(_vm.htmlContent)}})]),_c('foot')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }